import { HelmetProvider } from 'react-helmet-async';
import { config } from '@/config';
import { SentryErrorBoundary } from '@/containers/Subscriber/Sentry.ErrorBoundary';
import { GlobalStylesContainer } from './GlobalStyles';
import { QueryParamsClient } from './QueryParamsClient';
import ReactQueryClient from './ReactQueryClient';
import { ReduxProvider } from './ReduxProvider';
import { RouteLogger } from './RouteLogger';

type Props = ChildrenProps;

export default function RootVendors({ children }: Props) {
  return (
    <SentryErrorBoundary>
      <ReactQueryClient>
        <QueryParamsClient>
          <ReduxProvider>
            <GlobalStylesContainer>
              <HelmetProvider>
                {config().APP_ENVIRONMENT === 'development' && <RouteLogger />}
                {children}
              </HelmetProvider>
            </GlobalStylesContainer>
          </ReduxProvider>
        </QueryParamsClient>
      </ReactQueryClient>
    </SentryErrorBoundary>
  );
}

export { RootVendors };